common.View.create('initiatief::canvas.blocks.modules.kernenkaartMap.Block', {

    onDOMLoad() {
        const wrapper = this.element.find('.kernenkaart-map-wrapper').get(0);
        if (!wrapper) return;

        const kernen = this.parseJson(wrapper.dataset.kernen);
        const baseUrl = wrapper.dataset.baseUrl || '';
        const tooltip = this.element.find('.kernenkaart-tooltip').get(0);
        const svg = this.element.find('.kernenkaart-svg').get(0);
        const polygons = this.element.find('.kernenkaart-svg polygon[data-name]');

        // Build lookup by name and kaart_regio (case-insensitive)
        const kernenMap = {};
        kernen.forEach(function (kern) {
            kernenMap[kern.naam.toLowerCase()] = kern;
            if (kern.kaart_regio) {
                kernenMap[kern.kaart_regio.toLowerCase()] = kern;
            }
        });

        // Add city name labels to each polygon (hidden on mobile via CSS)
        if (svg) {
            this.addCityLabels(svg, polygons);
        }

        polygons.each(function (_, polygon) {
            const name = polygon.getAttribute('data-name');
            const kern = kernenMap[name.toLowerCase()];

            polygon.addEventListener('mouseenter', function (e) {
                polygon.classList.add('is-active');
                tooltip.style.display = 'block';
                tooltip.innerHTML = buildTooltip(name, kern);
            });

            polygon.addEventListener('mousemove', function (e) {
                var rect = wrapper.getBoundingClientRect();
                var x = e.clientX - rect.left + 16;
                var y = e.clientY - rect.top - 10;

                // Keep tooltip in bounds
                if (x + 220 > rect.width) {
                    x = e.clientX - rect.left - 230;
                }

                tooltip.style.left = x + 'px';
                tooltip.style.top = y + 'px';
            });

            polygon.addEventListener('mouseleave', function () {
                polygon.classList.remove('is-active');
                tooltip.style.display = 'none';
            });

            if (kern && kern.slug && baseUrl) {
                polygon.style.cursor = 'pointer';
                polygon.addEventListener('click', function () {
                    window.location.href = baseUrl + '?kern=' + encodeURIComponent(kern.slug);
                });
            }
        });

        function buildTooltip(name, kern) {
            var html = '<div class="kernenkaart-tooltip__header">';
            html += '<i class="fa-solid fa-location-dot kernenkaart-tooltip__header-icon"></i>';
            html += '<span>' + escapeHtml(name) + '</span>';
            html += '</div>';

            if (kern) {
                var pct = Math.min(Math.round(kern.percentage_besteed), 100);

                html += '<div class="kernenkaart-tooltip__rows">';
                html += tooltipRow('fa-solid fa-wallet', 'Budget', '&euro; ' + formatNumber(kern.totaal_budget));
                html += tooltipRow('fa-solid fa-check-circle', 'Toegekend', '&euro; ' + formatNumber(kern.toegekend));
                html += tooltipRow('fa-solid fa-coins', 'Beschikbaar', '&euro; ' + formatNumber(kern.beschikbaar));
                html += tooltipRow('fa-solid fa-lightbulb', 'Initiatieven', kern.aantal_goedgekeurd);
                html += '</div>';

                html += '<div class="kernenkaart-tooltip__progress">';
                html += '<div class="kernenkaart-tooltip__progress-bar">';
                html += '<div class="kernenkaart-tooltip__progress-fill" style="width: ' + pct + '%"></div>';
                html += '</div>';
                html += '<span class="kernenkaart-tooltip__progress-label">' + pct + '% besteed</span>';
                html += '</div>';
            }

            return html;
        }

        function tooltipRow(icon, label, value) {
            return '<div class="kernenkaart-tooltip__row">'
                + '<span class="kernenkaart-tooltip__row-label"><i class="' + icon + '"></i>' + label + '</span>'
                + '<span class="kernenkaart-tooltip__row-value">' + value + '</span>'
                + '</div>';
        }

        function formatNumber(value) {
            return parseFloat(value).toLocaleString('nl-NL', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }

        function escapeHtml(text) {
            var div = document.createElement('div');
            div.textContent = text;
            return div.innerHTML;
        }
    },

    addCityLabels(svg, polygons) {
        var ns = 'http://www.w3.org/2000/svg';
        var labelGroup = document.createElementNS(ns, 'g');
        labelGroup.setAttribute('class', 'kernenkaart-labels');

        var fontSize = 4.5;

        // Manual positions to keep labels centered within their polygons
        var positions = {
            'Lewedorp': { x: 65, y: 53 },
            'Nieuwdorp': { x: 55, y: 105 },
            'Borssele': { x: 80, y: 175 },
            "'s-Heerenhoek": { x: 102, y: 118 },
            'Heinkenszand': { x: 148, y: 98 },
            "'s-Heer Abtskerke": { x: 207, y: 85 },
            "'s-Gravenpolder": { x: 258, y: 120 },
            'Nisse': { x: 190, y: 138 },
            'Kwadendamme': { x: 226, y: 155 },
            'Ovezande': { x: 140, y: 158 },
            'Driewegen': { x: 136, y: 187 },
            'Ellewoutsdijk': { x: 153, y: 232 },
            'Oudelande': { x: 186, y: 208 },
            'Hoedekenskerke': { x: 258, y: 168 },
            'Baarland': { x: 240, y: 210 },
        };

        polygons.each(function (_, polygon) {
            var name = polygon.getAttribute('data-name');
            if (!name) return;

            var pos = positions[name];
            if (!pos) return;

            var text = document.createElementNS(ns, 'text');
            text.setAttribute('x', pos.x);
            text.setAttribute('y', pos.y);
            text.setAttribute('text-anchor', 'middle');
            text.setAttribute('dominant-baseline', 'central');
            text.setAttribute('font-size', fontSize);
            text.setAttribute('class', 'kernenkaart-label');
            text.textContent = name;

            labelGroup.appendChild(text);
        });

        svg.appendChild(labelGroup);
    },

    parseJson(raw) {
        if (!raw) return [];
        try {
            var parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            return [];
        }
    },
});